import { BorrowerEntity } from '../../../../../queries/borrowerEntityQueries';
import { CardSectionLabel } from '../../../../CardSectionLabel';
import { hasEntityAddress } from '../functions/hasEntityAddress';

/** "Address:" and the entity's street and city lines; nothing when it has no address. */
export const BorrowerEntityAddress = ({ entity }: { entity: BorrowerEntity }) => {
    const hasCityLine = !!(entity.city && entity.state && entity.zipCode);

    if (!hasEntityAddress(entity)) {
        return null;
    }

    return (
        <div>
            <CardSectionLabel>Address:</CardSectionLabel>
            {entity.street1 && <div>{entity.street1}</div>}
            {entity.street2 && <div>{entity.street2}</div>}
            {hasCityLine && (
                <div>
                    {entity.city}, {entity.state} {entity.zipCode}
                </div>
            )}
        </div>
    );
};
